import { isFinanceProject, isGlobalProject } from 'config';

export const getLegalClientMainFormSectionKeys = (): string[] => {
  if (isFinanceProject()) {
    return [
      'companyName',
      'organizationalAndLegalForm',
      'companyStateRegistration',
      'registrationPlace',
      'companyTaxResidences',
      'companyLicense',
    ];
  }

  if (isGlobalProject()) {
    return [
      'companyName',
      'organizationalAndLegalForm',
      'companyStateRegistration',
      'registrationPlace',
      'companyTaxResidences',
      'companyLicense',
      'identificationNumbers',
    ];
  }

  return [];
};
